"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _servicingActions = require("../actions/servicing-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  documentsByApplicationUuid: {// '286fcce0-6811-4575-946b-c5060e9f81fc': [
    //   {
    //     // statement example
    //     assetUuid: '81b57aca-d1e3-40c8-8f9c-7447bb181d3b',
    //     borrowerUuid: '8daab982-2eae-4f08-b2c1-638e53c84a1e',
    //     createdDate: '2019-11-18',
    //     docDescription: 'Servicing Statement',
    //     docType: 'SERVICINGSTATEMENT',
    //     docgenStatus: 'DOCGEN_STATUS_COMPLETE',
    //     fidoUuid: 'a9d43c32-ccb1-495b-9d27-43781218ef90',
    //     fileName: 'Servicing_Statement_2019-11-18.pdf',
    //     servicingUuid: '8134fb6b-29ab-4458-a9fd-a62743786534',
    //     statementEndDate: '2019-11-18',
    //     statementStartDate: '2019-10-19',
    //     tags: {
    //       HELOC_ASSET: '81b57aca-d1e3-40c8-8f9c-7447bb181d3b',
    //       IDENTITY_UUID: '8daab982-2eae-4f08-b2c1-638e53c84a1e',
    //     },
    //   },
    //   {
    //     // document example
    //     assetUuid: '81b57aca-d1e3-40c8-8f9c-7447bb181d3b',
    //     borrowerUuid: '8daab982-2eae-4f08-b2c1-638e53c84a1e',
    //     createdDate: '2019-10-12',
    //     docDescription: 'Delinquency SCRA Notice',
    //     docType: 'DELINQUENCY_SCRA_NOTICE',
    //     docgenStatus: 'DOCGEN_STATUS_COMPLETE',
    //     fidoUuid: '68cc88a7-6632-4f6e-8034-dd10235d3250',
    //     fileName: 'Delinquency_Scra_Notice_2019-10-12.pdf',
    //     servicingUuid: '24289dd3-e94e-415c-a5ed-f849bf98a24c',
    //     tags: {
    //       HELOC_ASSET: '81b57aca-d1e3-40c8-8f9c-7447bb181d3b',
    //       IDENTITY_UUID: '8daab982-2eae-4f08-b2c1-638e53c84a1e',
    //     },
    //   },
    // ],
  },
  loading: false,
  error: ''
};
exports.initialState = initialState;

function merge(state, action) {
  var applicationId = action.meta.assetId;
  return _objectSpread(_objectSpread({}, state), {}, {
    documentsByApplicationUuid: _objectSpread(_objectSpread({}, state.documentsByApplicationUuid), {}, (0, _defineProperty2.default)({}, applicationId, action.payload)),
    loading: false,
    error: ''
  });
}
/**
 * The difference between this reducer, and document-generated-reducer and servicing-statement-reducer,
 * is that the two latter once hit service-application, whereas the former accesses a service-servicing
 * endpoint, and combines documents, notices, and statements for an asset id.
 */


var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_SERVICING_DOCUMENTS, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_SERVICING_DOCUMENTS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return merge(state, action);
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;